import { render, staticRenderFns } from "./IconCheckCircleV5.vue?vue&type=template&id=56d61ac5"
import script from "./IconCheckCircleV5.vue?vue&type=script&lang=js"
export * from "./IconCheckCircleV5.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports